import React from "react";
import pointIcon from "../../../Assets/point_icon.svg";
import getTranslationData from "../../../TranslationUtility/TranslationUtility";
import { allZero, formatPrice } from "../../Utility/Utility";
import { useCheckoutContext } from "../context/CheckoutContext";

const BuyNowButton = ({
  onSubmit,
  isTransactionLimitExceeded,
  isRedemptionRequired,
  isRedemptionChecked,
  journeyType,
}) => {
  const translation = getTranslationData();
  const {
    quantities,
    disabled,
    stockOutDenominations,
    points,
    cash,
    totalPayableAmount,
    isBuyNowAmountUpdating,
  } =
    useCheckoutContext();

  return (
    <div className="mobile-sticky-footer">
      <div className="col-lg-12 col-12 mt-4 text-center mb-4">
        <button
          className="col-lg-12 col-12 clr-white buy-detailcart buy-now"
          disabled={
            allZero(quantities) ||
            disabled ||
            stockOutDenominations ||
            isTransactionLimitExceeded ||
            (isRedemptionRequired && !isRedemptionChecked)
          }
          onClick={onSubmit}
        >
          {translation?.buyNow}{" "}
          {!allZero(quantities) && !stockOutDenominations && translation.with}

          {!allZero(quantities) &&
            (isBuyNowAmountUpdating ? (
              <span
                className="buy-now-amount-wrap"
                aria-live="polite"
                aria-label="Updating amount"
              >
                <span className="buy-now-inline-loader">
                  <span className="buy-now-inline-loader__spinner" />
                </span>
              </span>
            ) : points > 0 ? (
              <span className="buy-now-amount-wrap">
                {!journeyType && (
                  <img src={pointIcon} alt="point-icon" className="point-icon" />
                )}
                {journeyType && <span>{translation?.pts}</span>}
                <span className="point_vale_show">{Number(points).toLocaleString("en-IN")}</span>
                {cash > 0 && <> <span className="cash-amount">+ ₹{formatPrice(cash)}</span></>}
              </span>
            ) : (
              !stockOutDenominations && (
                <span className="buy-now-amount-wrap">
                  ₹{formatPrice(totalPayableAmount)}
                </span>
              )
            ))}
        </button>
      </div>
    </div>
  );
};

export default BuyNowButton;
